module.exports = __webpack_public_path__ + "img/ps-15.2accce70.jpg";